
import Vue from 'vue';
import Component from "vue-class-component";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import {
    factory,
    ResultError,
    SysAdminHarboursClient,
    UpsertHarbourRequest, CountryLightModel, CountriesClient
} from "@/api-client";
import {translateTrueFalse} from "@/features/shared/TrueFalseTranslator";
import toasts from "@/components/Toasts";
import LabelOptional from "@/features/shared/components/LabelOptional.vue";
import AdministrationDetailviewLayout from "@/features/administration/AdministrationDetailviewLayout.vue";
import {Route} from "vue-router";
import {Prop} from "vue-property-decorator";
import ErrorsSummary from "@/components/ErrorsSummary.vue";

@Component({
    components: {
        HeadingWave,
        LabelOptional,
        AdministrationDetailviewLayout,
        ErrorsSummary
    },
})
export default class UpsertHarbour extends Vue {
    async beforeRouteEnter(to: Route, from: Route, next: Function) {
        try {
            if (to.params.id) {
                const harbourToUpdate = await new SysAdminHarboursClient().details(to.params.id);
                to.meta!.props.preloadedModel = new UpsertHarbourRequest({
                    id: harbourToUpdate.id,
                    name: harbourToUpdate.name,
                    countryLetterCode: harbourToUpdate.countryLetterCode,
                    harbourCode: harbourToUpdate.harbourCode,
                    additionalInformation: harbourToUpdate.additionalInformation,
                    isActive: harbourToUpdate.isActive
                });
            }
            to.meta!.props.countryOptions = await new CountriesClient().countries();
            next();
        } catch (e) {
            next(e);
        }
    }

    @Prop({required: false, default: () => factory.create(UpsertHarbourRequest)})
    preloadedModel!: UpsertHarbourRequest;

    @Prop({ required: true })
    countryOptions!: CountryLightModel[];

    model = this.preloadedModel;

    validationErrors: ResultError = ResultError.createEmpty();

    yesNoOptions = [
        {value: true, text: translateTrueFalse(true)},
        {value: false, text: translateTrueFalse(false)}
    ];

    async created() {
        if (this.model.isActive == null)
            this.model.isActive = true;
    }

    async save() {
        this.validationErrors = ResultError.createEmpty();

        await new SysAdminHarboursClient().upsert(this.model)
            .then(
                successResponse => {
                    this.$router.push({name: 'harbours'});
                    toasts.success(this.$ls.Administration_Harbours_Toasts_SuccessfullySaved);
                },
                (errorResponse: ResultError) => {
                    this.validationErrors = errorResponse;
                    toasts.failure(this.$ls.Global_Toast_ActionFailureWithErrorsAbove);
                });
    }
}
